import type { FluxErrorCode } from '../errors.codes.js';
import { FLUX_ERROR_MESSAGES } from '../errors.messages.js';
import type { FluxErrorCodeMessage } from '../types.js';
import { getFluxErrorCategory } from './get-flux-error-category.util.js';
import { getFluxErrorDocPaths } from './get-flux-error-doc-paths.util.js';

export interface FluxErrorCompleteMetadata extends FluxErrorCodeMessage {
  category: ReturnType<typeof getFluxErrorCategory>;
  /**
   * Código do erro no formato `${Categoria}/${Erro}`
   */
  code: string;
  docPath: ReturnType<typeof getFluxErrorDocPaths>;
  /**
   * Indica o código de erro original para o qual esse metadata está servindo como fallback,
   * caso o código de erro solicitado não exista.
   */
  fallbackFor: string | null;
}

export function getFluxErrorMetadata(errorCode: FluxErrorCode): FluxErrorCompleteMetadata {
  const errorMessage = FLUX_ERROR_MESSAGES[errorCode] as FluxErrorCodeMessage;

  if (!errorMessage) {
    return {
      ...getFluxErrorMetadata('UNKNOWN'),
      fallbackFor: errorCode,
    };
  }

  const categoryMetadata = getFluxErrorCategory(errorCode);

  return {
    ...errorMessage,
    code: errorCode,
    category: categoryMetadata,
    docPath: getFluxErrorDocPaths(errorCode),
    fallbackFor: null,
  };
}
